import * as React from 'react';

import IconFileBase from './IconFileBase';
import { Icon } from '../iconTypes';

const IconFileGoogleDocs = (props: Icon) => (
    <IconFileBase {...props} baseClassName="icon-file-google-docs">
        <path d="M25 27H7V5h13l5 5v17z" fill="#FFFFFF" />
        <path
            d="M20 4H7c-.6 0-1 .4-1 1v22c0 .6.4 1 1 1h18c.6 0 1-.4 1-1V9.9L20 4zm5 23H7V5h13v4c0 .6.4 1 1 1h4v17z"
            fill="#4083F7"
        />
        <path d="M10 15h11v1H10v-1zm0 2h11v1H10v-1zm0 2h11v1H10v-1zm0 2h8v1h-8v-1z" fill="#4083F7" />
    </IconFileBase>
);

export default IconFileGoogleDocs;
